import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCompanyInfoStep = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		transform: "translate(0 0.75) scale(1.5)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M8.82833 6.69333H12.2443C13.0415 6.69333 13.44 6.69333 13.7445 6.84847C14.0123 6.98493 14.2301 7.20267 14.3665 7.47049C14.5217 7.77496 14.5217 8.17353 14.5217 8.97067V13.81M8.82833 13.81V3.27733C8.82833 2.48019 8.82833 2.08162 8.6732 1.77715C8.53674 1.50934 8.319 1.29159 8.05118 1.15513C7.74671 1 7.34814 1 6.551 1H3.989C3.19186 1 2.79329 1 2.48882 1.15513C2.221 1.29159 2.00326 1.50934 1.8668 1.77715C1.71167 2.08162 1.71167 2.48019 1.71167 3.27733V13.81M15.2333 13.81H1M4.2025 3.84667H6.3375M4.2025 6.69333H6.3375M4.2025 9.54H6.3375",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	})]
});
const ForwardRef = forwardRef(SvgCompanyInfoStep);
export default ForwardRef;
